<template>
  <div class="ad-container">
    <div class="details">
      <Icons
        :class="iconType"
        :name="`${iconType}-ad-tag`"
        :style="`--icon-size: ${iconSize};`"
      />
      <span v-if="title" class="title">{{ title }}</span>
    </div>
    <span v-if="optionTypeText" class="option-type-text">
      {{ optionTypeText }}
    </span>
  </div>
</template>

<script>
import Icons from '@sephora-asia/atoms-icons/Icons.vue'

export default {
  name: 'Ad',
  components: {
    Icons
  },
  props: {
    /**
     * Title shows next to the icon
     *
     * @type {string}
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Option types text which shows below the title. e.g. Selected shades only
     *
     * @type {string}
     */
    optionTypeText: {
      type: String,
      default: ''
    },
    /**
     * Icon size
     *
     * @type {string}
     */
    iconSize: {
      type: String,
      default: '18px'
    },
    /**
     * Icon type
     *
     * @type {string}
     */
    iconType: {
      type: String,
      default: 'promotion',
      validator: function (value) {
        return ['promotion', 'virtual-bundle'].includes(value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-container {
  vertical-align: sub;

  &.promotion {
    fill: $red;
  }

  &:hover {
    --icon-hover-fill-color: #{$red};
  }
}
.details {
  display: flex;
  align-items: center;
  gap: 3px;
}
.title {
  font-weight: 500;
  font-size: 15px;
  padding-top: 2.5px;
}
.option-type-text {
  font-size: 11px;
}
</style>
